import css from 'styled-jsx/css';

const styles = css.global`body {
    -webkit-font-smoothing: antialiased; /* Melhora a suavização no Mac */
    -moz-osx-font-smoothing: grayscale; /* Reduz o peso da fonte no Mac */
  }

  @media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }
  }`;

export default styles;